import type { FC } from 'react';

import { useAssistantEnabled } from 'features/onboarding/lib/useAssistantEnabled';

import { InkeepChat } from './InkeepChat';

export const ChatIntegration: FC = () => {
  const assistantEnabled = useAssistantEnabled();

  // Inkeep and the assistant are both an "Ask Truv AI" button docked bottom-right, so with the
  // assistant rolled out they stacked into two buttons over two different chats (CL-6818). The
  // assistant wins: its search_truv_docs tool answers from the same Inkeep-indexed documentation.
  // Gate here rather than inside InkeepChat so the widget's config hook — and the widget-settings
  // request it makes — never runs for users who won't see it.
  return assistantEnabled ? null : <InkeepChat />;
};
